export const SWIPE_DIRECTION_LEFT = 'left';
export const SWIPE_DIRECTION_RIGHT = 'right';
export const SPEED_ANIMATION = 300;
export const MAX_DISTANCE_FOR_NOT_SWIPE = 50;